import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExceedTicketDialogService {
  private _isOpen = new BehaviorSubject<boolean>(false);
  private _ticketsRemaining = new BehaviorSubject<number>(0);

  public isOpen$ = this._isOpen.asObservable();
  public ticketsRemaining$ = this._ticketsRemaining.asObservable();

  openDialog(ticketsRemaining: number): void {
    this._ticketsRemaining.next(Math.max(0, ticketsRemaining));
    this._isOpen.next(true);
  }

  closeDialog(): void {
    this._isOpen.next(false);
  }
}
